import { fetchData } from '../global/utils/fetch'

export function getDocuments() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/documents`,
  }
}

export function deleteDocument(documentObjectId: string) {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/documents/${documentObjectId}`,
  }
}

export async function uploadDocument(
  file: File,
  name: string,
  description?: string,
): Promise<{ documentObjectId: string; name: string; totalChunks: number }> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('name', name)
  if (description) {
    formData.append('description', description)
  }

  return fetchData({
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/documents/upload`,
    body: formData,
  })
}
